const actionItems = {
  getActionItemColor(completed) {
    if (completed == null) {
      return "error";
    } else if (completed) {
      return "success";
    }
    return "info";
  },
  getActionItemIcon(completed) {
    if (completed == null) {
      return "notifications_active";
    } else if (completed) {
      return "done";
    }
    return "check_box_outline_blank";
  },
  getActionItemName(completed) {
    if (completed == null) {
      return "Overdue";
    } else if (completed) {
      return "Complete";
    }
    return "Open";
  }
};

export default { methods: actionItems };
